exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3OLgKoz_mpOZSe{height:100vh;display:flex;align-items:center;background-color:#f4f5f7}", ""]);

// exports
exports.locals = {
	"spinner": "_3OLgKoz_mpOZSe"
};